import { unwrap } from '../../util/helpers';
import ourProductsModule from './our-products';

export default {
  init() {
    this.$modules = document.querySelectorAll('.ms-product-grid');

    if ( !this.$modules.length ){
      return;
    }

    this.$modules.forEach($module => {
      // Render category filters
      this.renderFilter($module);
    });
  },

  fetchProdGrid($module, dataCategory, taxonomy, isParent) {
    const $list = $module.querySelector('.ms-product-grid__cards');
    const title = $module.querySelector('.ms-product-grid__title').innerHTML;
    const ourProducts = $module.nextElementSibling;
    const ajaxurl = window.msAjax.ajax_url;
    fetch(ajaxurl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }),
      body: `action=fetch_prod_grid_data&filter=${dataCategory}&taxonomy=${taxonomy}&is_parent=${isParent}&section_title=${title}`,
    })
      .then((resp) => resp.json())
      .then(function (data) {
        const { html, swap } = data;

        // swap == change to Our Products
        if (swap) {
          $module.style.display = 'none';
          ourProducts.innerHTML = html;
          unwrap(ourProducts);

          // Re-init our-products module.
          ourProductsModule.init();
        } else {
          $list.innerHTML = html;

          // SR only. Create this on-the-fly for announcement
          const a11yLive = document.createElement('span');
          a11yLive.setAttribute('aria-live', 'polite');
          a11yLive.classList.add('ms-product-grid__announcement');
          a11yLive.innerHTML = 'content updated';

          // append to the main module
          $module.appendChild(a11yLive);

          // remove it after announcing, estimated 2 seconds
          setTimeout(() => {
            a11yLive.remove();
          }, 2000);
        }

      })
      .catch(function (error) {
        console.log(JSON.stringify(error));
      });
  },

  renderFilter($module) {
    // Filter navigation event
    const $filterParent = $module.querySelector('.ms-product-grid__filter');
    const taxonomy = $filterParent.dataset.tax;
    const singleSubCat = $filterParent.dataset.subCat;
    const isParent = Boolean($filterParent.dataset.isParent);
    const $filterElements = $filterParent.querySelectorAll('.ms-product-grid__filter [data-cat]');

    // initial fetch from first button in the list
    this.fetchProdGrid($module, singleSubCat ? singleSubCat : $filterElements[0].dataset.cat, taxonomy, isParent);

    if ($filterElements.length) {
      $filterElements.forEach((item) => {
        item.addEventListener('click', ({ target }) => {
          // former active
          const prevActive = $module.querySelector('.active');
          prevActive && prevActive.classList.remove('active');
          $filterElements.forEach(el => el.setAttribute('aria-pressed', 'false'));
          target && target.setAttribute('aria-pressed', 'true')

          // new active
          target && target.classList.add('active');
          const dataCategory = item.dataset.cat;
          this.fetchProdGrid($module, dataCategory, taxonomy, isParent);
        });
      })
    }
  },

  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/modules/product-grid.js